(function () {
    'use strict';

    angular
        .module('app.cookies', [
            'app.core',
            'utils'
        ]);
})();